import api from '@/store/api'
import { rawThemeFormState } from '@/utils/meta.js'
import { getField, updateField } from 'vuex-map-fields'

const state = {
	themes: {
		data: [],
		last_page: 0,
		total: 0,
		to: 0,
		from: 0
	},
	filter: {
		keyword: '',
		page: 1,
		count: 10,
		sort_by: '',
		theme_filter: []
	},
	form: {
		name: '',
		description: '',
		image: {
			server_name: '',
			value: null
		}
	},
	lastViewForm: {
		name: '',
		description: '',
		image: {
			server_name: '',
			value: null
		}
	},
	errors: {
		name: '',
		description: '',
		image: ''
	},
	isLoading: false,
	btnLoading: false,
	isImageLoading: false
}

const mutations = {
	updateField,
	clearFormState (state) {
		state.form = JSON.parse(JSON.stringify(rawThemeFormState.form))
	},
	setTheme (state, payload) {
		Object.keys(state.form).forEach(key => {
			if (key === 'image') {
				state.form.image.server_name = payload[key]
				state.form.image.value = `${process.env.VUE_APP_PATH_FOLDER}/theme/${payload[key]}`
				state.lastViewForm.image.server_name = payload[key]
			} else {
				state.form[key] = payload[key]
				state.lastViewForm[key] = payload[key]
			}
		})
		state.form.id = payload.id
	}
}

const actions = {
	async fetchThemes ({ state }, payload) {
		state.isLoading = true
		const { data, status } = await api('get', `theme-list${payload}`)

		if (status) {
			state.themes.data = data.data.data
			state.filter.page = data.data.current_page
			state.themes.last_page = data.data.last_page
			state.themes.total = data.data.total
			state.themes.to = data.data.to
			state.themes.from = data.data.from
			state.filter.count = Number(data.data.per_page)
		} else {
			state.themes = []
		}
		state.isLoading = false
	},
	async create ({ state, commit, dispatch }, { form, callback }) {
		state.btnLoading = true
		const { data, status } = await api('post', 'add-theme', form)
		if (status) {
			callback()
			commit('clearFormState')
		} else {
			if (data.message) {
				state.errors.name = data.message
			}
			!data.message && dispatch('toggleBanner', {
				message: 'Something went wrong.',
				type: 'error'
			}, { root: true })
		}
		state.btnLoading = false
	},
	async view ({ state, commit, dispatch }, payload) {
		state.isLoading = true
		const { status, data } = await api('get', `theme-view?id=${payload}`)
		if (status) {
			commit('setTheme', data.data)
		} else {
			state.themes = []

			dispatch('toggleBanner', {
				message: 'Something went wrong.',
				type: 'error'
			}, { root: true })
		}
		state.isLoading = false
	},
	async update ({ state, commit, dispatch }, { form, callback }) {
		state.btnLoading = true
		const { data, status } = await api('post', 'update-theme', form)
		if (status) {
			callback()
			commit('clearFormState')
		} else {
			if (data.message) {
				state.errors.name = data.message
			}
			!data.message && dispatch('toggleBanner', {
				message: 'Something went wrong.',
				type: 'error'
			}, { root: true })
		}
		state.btnLoading = false
	},
	async tempUpload ({ state }, form) {
		state.isImageLoading = true
		const { data, status } = await api('post', 'temp-upload', form)

		if (status) {
			state.form.image.server_name = data.data.server_name
		}
		state.isImageLoading = false
	}
}

const getters = {
	getField,
	btnLoading: state => state.btnLoading,
	themeList: state => state.themes,
	hasChanged: state => {
		const { lastViewForm, form } = state

		return Object.keys(lastViewForm).some(key => {
			if (key === 'image') {
				return lastViewForm.image.server_name !== form.image.server_name
			}

			return lastViewForm[key] !== form[key]
		})
	},
	isLoading: state => state.isLoading,
	isImageLoading: state => state.isImageLoading
}

export default {
	state,
	getters,
	mutations,
	actions,
	namespaced: true
}
